import { motion } from 'framer-motion';

const Experience = ({ experiences }) => {
  const defaultExperiences = [
    {
      _id: '1', position: 'Full Stack Developer', company: 'Tech Company',
      startDate: '2023', endDate: 'Present', current: true,
      description: 'Developing and maintaining web applications using MERN stack.'
    },
    {
      _id: '2', position: 'Frontend Developer', company: 'Startup Inc.',
      startDate: '2022', endDate: '2023',
      description: 'Built responsive UI components with React.js and modern CSS.'
    },
    {
      _id: '3', position: 'Junior Developer', company: 'Web Agency',
      startDate: '2021', endDate: '2022',
      description: 'Worked on client websites using HTML, CSS, JavaScript, and WordPress.'
    }
  ];

  const displayExperiences = experiences.length > 0 ? experiences : defaultExperiences;

  return (
    <section className="experience section" id="experience">
      <div className="container">
        <div className="section-title">
          <h2>Experience</h2>
          <p>My professional journey</p>
        </div>
        <div className="timeline">
          {displayExperiences.map((exp, idx) => (
            <motion.div
              key={exp._id}
              className="timeline-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.15 }}
            >
              <div className="timeline-content">
                <h3>{exp.position}</h3>
                <h4>{exp.company}</h4>
                <p className="date">{exp.startDate} - {exp.endDate || 'Present'}</p>
                <p>{exp.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
